import { lazy, Suspense, useEffect, useState } from "react";

const LazyTravelMap = lazy(() =>
  import("@/components/TravelMap").then((m) => ({ default: m.TravelMap })),
);

function Placeholder() {
  return (
    <div className="grid h-[420px] w-full place-items-center rounded-xl border border-border bg-card text-sm text-muted-foreground">
      Loading travel map…
    </div>
  );
}

export function TravelMapClient() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  if (!mounted) return <Placeholder />;

  return (
    <Suspense fallback={<Placeholder />}>
      <LazyTravelMap />
    </Suspense>
  );
}
